// extracted by mini-css-extract-plugin
module.exports = {"Main":"MainSection_Main__38G_G","Loader":"MainSection_Loader__2K2x9"};